import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { offer } from '../data/offer';
export function ScarcityBar() {
  const claimed = offer.spotsTotal - offer.spotsLeft;
  const pct = Math.round(claimed / offer.spotsTotal * 100);
  return <div className="mx-auto mt-8 w-full max-w-xl rounded-2xl bg-white p-5 text-ink" data-id="element-265" data-mp="2q40xwem6aetq">
      <p className="flex items-center gap-2 text-[16px] font-bold leading-snug" data-id="element-266" data-mp="2q1o8xhhzz476">
        <FlameIcon className="h-5 w-5 shrink-0 text-alert-600" aria-hidden="true" data-id="element-267" data-mp="2b5fauj9uewwc" />
        <span data-id="element-268" data-mp="2g7eg5yp583vx">
          Only <span className="text-alert-600" data-id="element-269" data-mp="2g3qluxbvjdg5">{offer.spotsLeft} spots left</span> at the promotional price
        </span>
      </p>
      <div className="mt-3 h-5 w-full overflow-hidden rounded-full bg-slate-200" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-270" data-mp="274vehhx3fxb9">
        <motion.div className="flex h-full items-center justify-end rounded-full bg-alert-600 pr-2" initial={{
        width: '40%'
      }} whileInView={{
        width: `${pct}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-271" data-mp="5d9zf8qe0y7p">
          <span className="text-[11px] font-bold text-white" data-id="element-272" data-mp="3dbwm67tefoin">{pct}%</span>
        </motion.div>
      </div>
      <p className="mt-2 text-[13px] text-muted" data-id="element-273" data-mp="38ed5z2d551o2">
        {claimed} of {offer.spotsTotal} launch spots already claimed. When they're gone, the price goes up.
      </p>
    </div>;
}